import 'polyfills';

import ReactOnRails from 'react-on-rails';

import FeatureFlagAlert from '../components/FeatureFlag/FeatureFlagAlert';
import Switcher from '../components/location/Switcher';
import CrossingLocale from '../components/location/CrossingLocale';
import View from '../components/Builder/View';
import WarrantyClaimsForm from '../components/Warranty/WarrantyClaimForm/warranty-claims.jsx';
import warrantyClaimStore from '../components/Warranty/WarrantyClaimForm/redux/store';
import Footer from '../components/OC/footer';
import Text from '../components/OC/oc-text';
import RichText from '../components/OC/oc-rich-text';

ReactOnRails.registerStore({
  warrantyClaimStore,
});

ReactOnRails.register({
  WarrantyClaimsForm: WarrantyClaimsForm,
  'Location::Switcher': Switcher,
  'Location::Crossinglocale': CrossingLocale,
  'FeatureFlag::Featureflagalert': FeatureFlagAlert,
  'Builder::View': View,
  'OC::Text': Text,
  'OC::Footer': Footer,
  'OC::Richtext': RichText,
});
